<template>
    <div>
        <v-toolbar flat :color="externalColor ?? color" height="40" dark>
            <v-toolbar-title>
                {{ externalTitle ?? $t(title) }}
            </v-toolbar-title>
        </v-toolbar>
    </div>
</template>

<script setup>
import useSharedMethod from "@/use/SharedMethod.js";
import {defineProps, ref, watch} from "vue";

const props = defineProps({
    overrideTitle: String,
    addAction: Boolean,
    updateAction: Boolean,
    deleteAction: Boolean,
    viewAction: Boolean,
    validateAction: Boolean,
    renewAction: Boolean,
    archiveAction: Boolean,
    unarchiveAction: Boolean,
    activateAction: Boolean,
    externalTitle: String,
    externalColor: String,
});

const {getDialogToolbar} = useSharedMethod();

const title = ref(null);
const color = ref(null);

watch(() => props, () => {
    let result = getDialogToolbar(props.addAction,
        props.updateAction,
        props.deleteAction,
        props.viewAction,
        props.validateAction,
        props.renewAction,
        props.archiveAction,
        props.unarchiveAction,
        props.activateAction);
    title.value = props.overrideTitle ? props.overrideTitle : result.title;
    color.value = result.color;
}, {deep: true, immediate: true});
</script>

<style scoped>

</style>